import React from 'react';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';

const buildSchema = (props, canonical, pageTitle, metaDescription, author) => {
  return {
    '@context': 'https://schema.org/',
    '@type': 'BlogPosting',
    '@id': canonical,
    mainEntityOfPage: canonical,
    name: pageTitle,
    headline: pageTitle,
    description: metaDescription?.metaDescription,
    datePublished: props?.publishDate,
    dateModified: props?.updatedAt,
    publisher: {
      '@type': 'Organization',
      '@id': 'https://www.servicetitan.com/',
      name: 'ServiceTitan',
      logo: {
        '@type': 'ImageObject',
        '@id':
          'https://images.ctfassets.net/3q1a0w8cwuwf/7ISRCzbAIAcs4MGNvrYSWN/67264761ca3557c758165afc41dc04a9/ServiceTitan_Logo_Black_2.png',
      },
    },
    author,
  };
};

const getAuthor = (author) => {
  if (!author || author.firstName?.includes('ServiceTitan')) {
    return {
      '@type': 'Organization',
      name: 'ServiceTitan',
      url: 'https://www.servicetitan.com/',
    };
  }
  const authorName = `${author.firstName} ${author.lastName}`?.trim();
  return {
    '@type': 'Person',
    name: authorName,
  };
};

export const generateFAQSchema = (data) => {
  if (!data) return null;
  const schema = data.map((z) => {
    const question = z.question?.question || z?.question || null;
    const answer = z.answer?.childMarkdownRemark?.html || z?.answer || null;
    return (
      question &&
      answer && {
        '@type': 'Question',
        name: question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: answer.replace(/(<([^>]+)>)/gi, ''),
        },
      }
    );
  });
  return schema;
};

export const generateRichTextFAQ = (body) => {
  if (!body?.raw) {
    return null;
  }
  const faqData = JSON.parse(body.raw).map((section) => {
    const text = documentToPlainTextString(section);
    const questionIndex = text.indexOf('?');

    return {
      question: text.substring(0, questionIndex + 1),
      answer: text.substring(questionIndex + 2),
    };
  });
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: generateFAQSchema(faqData),
  };
};

export const generateBreadcrumbSchema = (data) => {
  if (!data) return null;

  const schema = data
    .filter((listItem) => !!listItem.title)
    .map((listItem, index) => {
      return {
        '@type': 'ListItem',
        position: index + 1,
        name: listItem.title,
        ...(listItem.url && { item: `https://www.servicetitan.com${listItem.url}` }),
      };
    });

  return schema;
};

export const generateBlogSchema = (data, props) => {
  if (!data) return null;

  const { blogProps } = props;
  const { canonicalUrl, pageTitle, metaDescription, pageUrl } = data;

  const canonical = canonicalUrl || `https://www.servicetitan.com${pageUrl}`;

  const author = getAuthor(blogProps?.author);
  const schema = buildSchema(blogProps, canonical, pageTitle, metaDescription, author);

  return schema;
};

export const getRobot = ({ indexable, follow }, slug) => {
  // PPC Landing page - default (no selection in Contentful)
  if (slug && (slug.startsWith('go/') || slug.startsWith('/go'))) {
    if (indexable === false || indexable === null) {
      return <meta name="ROBOTS" content="NOINDEX, FOLLOW" />;
    }
  }

  // Indexable || no chosen value
  if (indexable === true || indexable === null) {
    return <meta name="ROBOTS" content={`INDEX, ${follow || 'FOLLOW'}`} />;
  }

  // Non-Indexable
  if (!indexable) {
    return <meta name="ROBOTS" content={`NOINDEX, ${follow || 'NOFOLLOW'}`} />;
  }

  return null;
};
